import { getUserPartcMeetingListFromAuthUserIdApi } from 'api/meeting';
import MeetingDataTable from 'app/components/DataTable/meeting/MeetingDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';
import config from 'config';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setAllUsersMeetingList, setPageType } from 'stores/meeting';

// tam okuma listesi 368,371
const AttendedMeetings = () => {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const authUser = useSelector(state => state.auth.authUser);
    const params = useParams();
    const param = params.pageType;

    const [pageTitle, setPageTitle] = useState("");
    const allUsersMeetingList = useSelector((state) => state.meeting.allUsersMeetingList);


    useEffect(() => {
        const getAPI = async () => {

            setLoading(true)
            dispatch(setPageType(param))
            let meetingList = [];

            if (param === "attented") {
                if (!(allUsersMeetingList !== undefined && allUsersMeetingList.length > 0)) {
                    const res = await getUserPartcMeetingListFromAuthUserIdApi(authUser.id);
                    meetingList = res.data
                    dispatch(setAllUsersMeetingList(meetingList));

                }
            } else {
                if (!(allUsersMeetingList !== undefined && allUsersMeetingList.length > 0)) {

                    const res = await getUserPartcMeetingListFromAuthUserIdApi(authUser.id);
                    meetingList = res.data
                    dispatch(setAllUsersMeetingList(meetingList));


                }
            }


            const cardTitle = config.dashboardCarsInfo.find(card => card.name === param);
            setPageTitle(cardTitle !== undefined ? cardTitle.title : "Toplantı Listesi")
            setLoading(false);

        }

        getAPI()
    }, [param])



    const columnData = [
        { id: 'id', align: 'left', disablePadding: false, label: "ID" },
        { id: 'inst', align: 'left', disablePadding: false, label: "Kurum" },
        { id: 'unit', align: 'left', disablePadding: true, label: "Kurul/Kol/Komisyon" },
        { id: 'meetingNo', align: 'left', disablePadding: false, label: "Toplantı No" },
        { id: 'pdate', align: 'left', disablePadding: true, label: "Tarih" },
        { id: 'adminUserId', align: 'center', disablePadding: false, label: "Toplantı Yöneticisi" },
        { id: 'decisionCount', align: 'left', disablePadding: true, label: "Karar Sayısı" },
        { id: 'userList', align: 'left', disablePadding: true, label: "Üyeler" },
        { id: 'participantList', align: 'left', disablePadding: true, label: "Katılımcılar" },
        { id: 'islemler', align: 'center', disablePadding: false, label: "İşlemler" },
        { id: 'islemler', align: 'center', disablePadding: false, label: "" }
    ];

    return (
        <React.Fragment>
            <>
                <LoadingPopUp open={loading} />
                {!loading && <MeetingDataTable column={columnData} pageTitle={pageTitle} loading={loading} setLoading={setLoading} />}
            </>
        </React.Fragment>
    );
};

export default AttendedMeetings;